"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimestampTelemetryProcessor = void 0;
/**
 * TimestampTelemetryProcessor attaches the current time to events as they are
 * processed. TelemetryProcessors are applied as soon as
 * (EventRecorder).recordEvent is called, so the current time is exactly the
 * time the event was recorded.
 */
class TimestampTelemetryProcessor {
    constructor(provider = { now: () => new Date() }) {
        this.provider = provider;
    }
    processEvent(event) {
        /**
         * toISOString() gives us an RFC 3339-encoded UTC date string format, which
         * is required for `scalar DateTime` input.
         */
        event.timestamp = this.provider.now().toISOString();
    }
}
exports.TimestampTelemetryProcessor = TimestampTelemetryProcessor;
//# sourceMappingURL=timestamp.js.map